export * from './english-iq-result';
export * from './english-iq-score-summary';
